






import { Component, Vue } from "vue-property-decorator";

@Component
export default class App extends Vue {
  created() {
    this.$i18n.locale = "zh-cn";
    try {
      localStorage.setItem("localeLanguage", "zh-cn");
    } catch (error) {
      console.log(error);
    }
  }
}
